/**
 * midiChartGeometry
 *
 * Pure mapping layer between MidiStreamStore bucket data and SVG rect geometry.
 * No Vue, no DOM, no rendering concerns in the store or the chart component.
 *
 * @param {Array}   buckets  Array(BUCKET_COUNT) of number|null from the store
 * @param {number}  W        SVG viewBox width  (e.g. 300)
 * @param {number}  H        SVG viewBox height (e.g. 80)
 * @returns {Array} Array of bar descriptor objects:
 *   { x, y, width, height, empty: bool, latest: bool }
 */
export function buildBars(buckets, W, H) {
  const count = buckets.length;
  const bw    = W / count;

  // Find the rightmost bucket that has real (non-null) data — it gets the
  // "latest" highlight colour in the chart.
  let latestIdx = -1;
  for (let i = count - 1; i >= 0; i--) {
    if (buckets[i] !== null) { latestIdx = i; break; }
  }

  return buckets.map((v, i) => {
    const val = v ?? 0;
    const bh  = (val / 127) * H;
    return {
      x:      i * bw,
      y:      H - bh,
      width:  bw - 1,
      height: bh,
      empty:  v === null,
      latest: i === latestIdx,
    };
  });
}
